// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Wrap_wrap__zxjSz","big":"Wrap_big__1JVmB"};